var React = require('react');

function BackendDropdownMenuDashboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"}));
}

BackendDropdownMenuDashboard.displayName = "BackendDropdownMenuDashboard";

BackendDropdownMenuDashboard.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = BackendDropdownMenuDashboard;

BackendDropdownMenuDashboard.default = BackendDropdownMenuDashboard;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-dashboard.svg
// module id = 1003
// module chunks = 0